import TagManager from 'react-gtm-module';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { type GetTagManagerArgs } from './googleTagManager.type';
import { selectGtmUserArgs } from '../../store/selectors/tracking';

interface PageViewEvent {
  pageName: string;
  pageType: string;
  pageCategory: string;
  additionalArgs?: Record<string, string | number | undefined>;
  dependencies?: (string | undefined)[];
  /**
   Allow to avoid noisy wrong tracking like in intervention page with an doc number
   */
  willTrack?: boolean;
}

export const usePageEventTracking = ({
  pageName,
  pageType,
  pageCategory,
  additionalArgs = {},
  dependencies = [],
  willTrack = true,
}: PageViewEvent) => {
  const gtmUserArgs = useSelector(selectGtmUserArgs);

  useEffect(() => {
    if (willTrack) {
      TagManager.dataLayer({
        dataLayer: {
          pageName,
          pageType,
          pageCategory,
          storeID: gtmUserArgs.selectedSite.id,
          countryCode: gtmUserArgs.selectedSite.address.countryCode,
          event: 'page_view',
          ...gtmUserArgs,
          ...additionalArgs,
        },
        dataLayerName: 'dataLayer',
      });
    }
  }, dependencies);
};

export function getTagManagerArgs({ event, label, params }: GetTagManagerArgs) {
  return {
    dataLayerName: 'dataLayer',
    dataLayer: {
      event,
      ...params,
      ...(label && { event_label: label }),
    },
  };
}
